
const ProductTab = (props) => {
  const { productDesc} = props;

  return (
    <>
      <h6  dangerouslySetInnerHTML={{ __html: productDesc }} />
    </>
  );
};

export default ProductTab;
